import { Component, Input, OnInit } from '@angular/core';
import { BlobDeletesViewStateService } from '../services/blob-deletes-view-state.service';
import { BlobDownloadsViewStateService } from '../services/blob-downloads-view-state.service';
import { BlobSharedViewStateService } from '../services/blob-shared-view-state.service';
import { environment } from './../../../environments/environment';
import { CookieService } from "ngx-cookie-service";
import { BlobItem } from '@azure/storage-blob';
import { Globals } from './../../globals'

@Component({
  selector: 'app-items-list',
  template: `
<div *ngIf="globals.verarchivos">
    <ng-container *ngIf="items$ | async as items">
      <ng-container *ngIf="items.length === 0">
        <span *ngIf="globals.lenguaje">No hay archivos cargados</span>
        <span *ngIf="!globals.lenguaje">No files uploaded</span>
      </ng-container>
      <div *ngFor="let item of items" style="width:100%">
        <div class="table-container"  style="border:solid; border-color:#ececec;padding: 20px 20px 20px 20px;width:80%">
          <div class="col-table-row">
            <div class="col-table-cell" style="width:90%"><span class="form-paragraph-inline" style="font-weight:bold"><a (click)="onDownloadClick(item.name)" class="link-no-position" style="text-align:left;color: #00B4DC; text-decoration: underline;">{{ item.name }}</a></span></div>
            <div class="col-table-cell" style="width:10%; text-align:right" *ngIf="!ConsultarShow"><input type="image" (click)="onDeleteClick(item.name)" src="./assets/img/51388.png" width="12px" height="12px"></div>        
          </div>        
          <div>
            <!--<button (click)="onDownloadClick(item.name)">Download</button>-->
            <!--<button (click)="onDeleteClick(item.name)">Delete</button>-->
          </div>          
        </div>
        <br/>
      </div>
      
    </ng-container>
</div>
  `
})
export class ItemsListComponent implements OnInit {
  items$ = this.blobState.itemsInContainer$;
  public lenguajeGlobal;
  texto: string;
  public verar: boolean = false;

  @Input()
  ConsultarShow: boolean;

  @Input()
  origen: string;

  constructor(
    private blobState: BlobSharedViewStateService,
    private blobDeletes: BlobDeletesViewStateService,
    private blobDownloads: BlobDownloadsViewStateService,
    private globals: Globals,
    private cookies: CookieService
  ) {
    this.blobState.itemsInContainer$.subscribe(data => this.doSomething(data.length));

    if (this.globals.path == "portal-back") {
      var lenguajeFuncionario = this.cookies.get("lenguajeFuncionario");
      this.lenguajeGlobal = lenguajeFuncionario;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
    else {
      var lenguajeTurista = this.cookies.get("lenguajeTurista");
      this.lenguajeGlobal = lenguajeTurista;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
  }
  ngOnInit() {
    this.blobState.itemsInContainer$.subscribe(data => this.doSomething(data.length));
  }

  doSomething(value) {
    var arrLength = value;
    if (arrLength > 0) {
      this.cookies.set("cargaarchivo" + this.origen, "true", 1, environment.raiz, environment.dominio, false, "Lax");
    }
    else {
      this.cookies.delete("cargaarchivo" + this.origen, environment.raiz, environment.dominio, false, "Lax");
      if (this.globals.path == "portal-back") {
        var lenguajeFuncionario = this.cookies.get("lenguajeFuncionario");
        this.lenguajeGlobal = lenguajeFuncionario;
        if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
          this.globals.lenguaje = true;
        } else {
          this.globals.lenguaje = false;
        }
      }
      else {
        var lenguajeTurista = this.cookies.get("lenguajeTurista");
        this.lenguajeGlobal = lenguajeTurista;
        if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
          this.globals.lenguaje = true;
        } else {
          this.globals.lenguaje = false;
        }
      }
    }
  }

  onDownloadClick(filename: string): void {
    this.blobDownloads.downloadItem(filename);
  }

  onDeleteClick(filename: string): void {
    this.blobDeletes.deleteItem(filename);
  }
}
